import Text from "../../Components/Text"

const ExpiredUser = () => {
    return (
        <div className="w-full h-full bg-white flex justify-center">
            <div className="w-full h-full flex flex-col p-3">
                <Text type="maintitle" classNames={"text-center"}>Das Workspace-Abonnement ist derzeit inaktiv.</Text>
                <Text type="itemtext" classNames={"text-center"}>Bitte wende dich an den Workspace-Besitzer, um das Abonnement zu verlängern.</Text>
            </div>
        </div>
    )
}

export default ExpiredUser